import api from './index';

// 分页查询水塘
export function fetchPonds(params) {
    return api.post('/web/fishpond/page', params);
}

// 新增水塘
export function createPond(data) {
    return api.post('/web/fishpond', data);
}

// 修改水塘名称
export function updatePond(pondId, data) {
    return api.put(`/web/fishpond/update/${pondId}`, data);
}

// 删除水塘
export function deletePond(pondId) {
    return api.delete(`/web/fishpond/${pondId}`);
}
